import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateAssetIdentification } from '../../../../state';

const AssetNameEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentAsset } = useAppSelector(state => state.asset);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateAssetIdentification({ name: event.target.value }));
  };

  return (
    <TextField
      label="Asset Name"
      size="small"
      required
      fullWidth
      value={currentAsset?.name || ''}
      onChange={handleChange}
    />
  );
};

export default AssetNameEdit;
